export default "__VITE_ASSET__98763039__"